import { killClone } from './clone';
import { fixStripes } from './utilities';
import { showLoginModal } from './modal';
import { setCookie, getCookie } from './cookies';
import { setMarkersKaart } from './setMarker';
import { Spinner } from '../vendor/spin.js';
import { getFerry } from '../pages/metsamaterjal.js';
export { Metsaoksjon };

let func, handleClick;

var n;

function Metsaoksjon() {
	this.lat = 0;
	this.lng = 0;
	this.zoom = 7;

	this.spinner;
	this.auctionLink = '';
	this.refreshTimer;
	this.refreshTimeout = 2;
	this.refreshItems = {
		"offer-listing": 1,
		"offer-history": 1
	};
	this.calculatorTimer = 0;
	this.loggedIn = function () {
		if ($(".logged-in").length) {
			return true;
		} else {
			return false;
		}
	};
	this.convertToHa = function (unit) {
		if (unit === "-") {
			return 0;
		}

		//if (unit.split(" ")[1] === "m²") {
		//    return (unit.split(" ")[0]) / 10000;
		//} else {
		//    return Number(unit.split(" ")[0]);
		//}

		var splitted = unit.split(" ");
		var pindala_val = splitted[0];
		var pindala_type = splitted[1]; // ha or m<sup>2</sup>

		if (pindala_type !== "ha") {
			pindala_val = (pindala_val / 10000).toFixed(2);
		}

		return Number(pindala_val);
	};
	this.ready = function () {
		this.makeSpinner();
		$(document).on("click", function () {
			$.noty.closeAll();
		});
		$(document).on("click", ".link", function () {
			log(this);
			return MO.action(this);
		});
		$(document).on("click", "a", function () {
			return MO.action(this);
		});
		/*
		// Dev kood
		$(document).on("click touchend", "a:not([class*=no-mo])", function () {
			return MO.action(this);
		});*/

		$(document).on("click", ".register-action", function () {
			var method = $(this).data('method');
			if (method) {
				$("#method").val(method);

				$(this).closest("form").submit();
			}
			return false;
		});
		$(document).on("change", ".body-select", function () {
			var val = $(this).val();

			$(".reg-item").hide();

			console.log(val);

			switch (val) {
				case '0':
					$(".reg-jur").show();
					break;
				default:
					$(".reg-era").show();
					break;
			}
		});
		$(document).on("click", ".packet-selection", function () {
			var packet = $(this).data("packet");
			var this_id = $(this).attr("id");
			$("." + packet).toggle();

			if ($("." + packet).is(":visible")) {
				$(this).html("<u>Peida</u>");
			} else {
				$(this).html("Loe lähemalt");
			}

			/*
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'WishToSell',
                'eventAction': this_id
            });
            */
			//dataLayer.push({'event': this_id});

			return false;
		});
		$(document).on("change", ".packets", function () {
			var packet = $(this).val();

			$(this).closest(".packets-block").find(".columns").each(function (e) {
				$(this).find("label").removeClass("active");
			});
			$(this).closest("label").addClass("active");

			$(".tyyp-metsakinnistu").hide();
			$(".tyyp-raieoigus").hide();
			$(".tyyp-metsamaterjal").hide();

			if (packet == "alghinnaga") {
				$(".tyyp-metsakinnistu").show();
				$(".tyyp-raieoigus").show();
				$(".tyyp-metsamaterjal").show();
			} else if (packet == "piirhinnaga") {
				$(".tyyp-metsakinnistu").show();
				$(".tyyp-raieoigus").show();
			} else { //taisteenuspakett
				$(".tyyp-metsakinnistu").show();
			}
			return false;
		});
		//$("#pakett-piirhinnaga").trigger("change");

		$(document).on("click", "#ky_action", function () {
			var val = $("#ky_value").val(),
				$this = $(this);

			$(".error").hide();
			//$("#ky-error").hide();
			//$("#ky-not-found").hide();

			if (val != "") {
				$this.prop("disabled", true);

				$(".cadastre-data").show().val("");

				$.ajax({
					url: "/resolve_ky/" + val
				}).always(function (data) {
					$this.prop("disabled", false);
					console.log("data", data);
				}).done(function (data) {
					var pieces = [];

					console.log("data", data);

					if (data == "error") {
						$("#ky-error").show();
					} else if (typeof data === "object") { // && data[1]
						//data = data[1];
						console.log(data);

						pieces.push(data["Maakond"]);
						pieces.push(data["Omavalitsus"]);
						pieces.push(data["Asustusüksus"]);
						pieces.push(data["Lähiaadress"]);

						console.log(pieces);

						//$(".cadastre-data").show().html(pieces.join(", "));
						$(".cadastre-data").show().val(pieces.join(", "));
					} else {
						$("#ky-not-found").show();
					}
				}).fail(function () {
					if (typeof error_ajax_query_failed != "undefined") {
						n = self.notify(error_ajax_query_failed, "error");
					}
				});
			}
			return false;
		});




		$(document).on("click", "[data-onclick]", function () {
			document.location = $(this).data("onclick");
			return false;
		});
		$(document).on("click", ".login-btn", function () {
			showLoginModal();
			return false;
		});

		$(document).on("click", ".popup-trigger", function () {
			let $this = $(this),
				popup = $this.data("popup"),
				popup_type = $this.data("popupType"),
				$popup = $("[data-popup=" + popup + "]"),
				$popup_overlay = $(".popup-overlay"),
				$body = $('body'),
				$message_type = $(".message-type", $popup)
			;

			if (window.innerWidth < 769) {
				if (!$body.hasClass('menu-open')) {
					$body.addClass('overflow-hidden');
				}
			} else {
				$("html, body").animate({
					scrollTop: 0
				}, 300);
				$(".content-wrapper").css("position", "relative");
			}

			if ($message_type.length) {
				if (popup_type) {
					$message_type.val(popup_type);
				}
			}

			$popup_overlay.addClass("popup-overlay-locked");
			$popup.show();

			return false;
		});
		$(document).on("change", ".tyybid", function () {
			switch ($(this).val()) {
				case 'metsamaterjal':
				case 'kinnistu_rent':
				case 'pollumaa':
					$("#kavaolemas_row").hide();
					$("#abi_row").hide();
					$("#fail_row").hide();

					$(".kavaolemas").prop("required", false);
					break;
				default:
					$("#kavaolemas_row").show();
					$("#abi_row").hide();
					$("#fail_row").hide();

					$(".kavaolemas").prop("required", true);

					break;
			}
			$(".kavaolemas").prop("checked", false);
			$(".soovinabi").prop("checked", false);

			$(".soovinabi").prop("required", false);

			fixStripes(".triibud tr", ".triibud tr:visible:odd", ".triibud tr:visible:even");
		});
		$(document).on("change", ".kavaolemas", function () {
			switch ($(this).val()) {
				case '1':
					$("#abi_row").hide();
					$("#fail_row").show();

					$(".soovinabi").prop("required", false);
					break;
				case '0':
					$("#abi_row").show();
					$("#fail_row").hide();

					$(".soovinabi").prop("required", true);
					break;
			}

			fixStripes(".triibud tr", ".triibud tr:visible:odd", ".triibud tr:visible:even");
		});
		$(document).on("submit", ".soovin_myya", function () {
			var val = $(".cadastre-data").val();
			$(".error").hide();
			if (val == "") {
				$("#ky-required").show();
				return false;
			}
		});
		$(document).on("click", "#mobile-id-start", function () {
			console.log("click", "mobile-id-start");
			MO.authByMobileID();
			return false;
		});

		fixStripes(".triibud tr", ".triibud tr:visible:odd", ".triibud tr:visible:even");

		$(document).on("click", "#login-id", function () {
			//confirm() Kontrollige, et ID-kaart oleks lugejas ja seejärel vajutage OK
			document.location = ID_CARD_AUTH_URL;
			return false;
		});

		$(document).on("click", "#login-mobile-id", function () {
			if ($("#login-modal").hasClass("mobile-id-active")) {
				$("#login-modal").removeClass("mobile-id-active");
				$("#mobile-id").slideUp("fast");
			} else if($("#login-modal").hasClass("smart-id-active")){
				$("#login-modal").removeClass("smart-id-active");
				$("#mobile-id").slideUp("fast");
				$("#login-modal").addClass("mobile-id-active");
				MO.authByMobileID('mid');
			}else {
				$("#login-modal").addClass("mobile-id-active");
				MO.authByMobileID('mid');
			}
			return false;
		});
		$(document).on("click", "#login-smart-id", function () {
			if ($("#login-modal").hasClass("smart-id-active")) {
				$("#login-modal").removeClass("smart-id-active");
				$("#mobile-id").slideUp("fast");
			}else if($("#login-modal").hasClass("mobile-id-active")){
				$("#login-modal").removeClass("mobile-id-active");
				$("#mobile-id").slideUp("fast");
				$("#login-modal").addClass("smart-id-active");
				MO.authByMobileID('sid');
			} else {
				$("#login-modal").addClass("smart-id-active");
				MO.authByMobileID('sid');
			}
			return false;
		});

		$(document).on("keypress", "#mobile-for-id", function (e) {
			if (e.which == 13) {
				e.preventDefault();
				MO.execMobileID();
			}
		});
		$(document).on("click", "#exec-mobile-id", function () {
			MO.execMobileID();
			return false;
		});
		$(document).on("keyup", function (e) {
			//console.log(typeof e.keyCode, e.keyCode);

			if (e.keyCode == 27) {
				if ($(".popup-overlay").is(":visible")) {
					$(".popup-overlay").hide();
					killClone();
				}
			} // esc
		});
		//81001:001:0900
		//var kits = $(".kitsendused");
		func = function(e) {
			var $this = $(this),
				part = $this.data("part"),
				val = $this.val(),
				partVal = $(".part1, .part2, .part3").val(),
				re = /^(\d{5}):(\d{3}):(\d{4})$/,
				res,
				kits = $this.closest(".kitsendused");

			//console.log(e.type, typeof e.keyCode, e.keyCode);

			if (e.type == "keyup") {
				if (e.keyCode == 8) {
					if (val == "") {
						if (part == 2) {
							$(".part1", kits).focus();
						} else if (part == 3) {
							$(".part2", kits).focus();
						}
					}
				}
				$this.closest(".kitsendused-container").find(".cadastral-clear").css("display", partVal == "" ? "none" : "inline-block") // Has to be inline-block
			} else {
				if (val != "") {
					res = re.exec(val);
					if (res) {
						$(".part1", kits).val(res[1]);
						$(".part2", kits).val(res[2]);
						$(".part3", kits).val(res[3]);
						return;
					}
				}
				if (re.test(val)) {
					//log("match");
				} else {
					val = this.value = this.value.replace(/[^0-9\.]/g, "");
				}
				if (part == 1 && val.length == 5) {
					$(".part2", kits).focus();
				} else if (part == 2 && val.length == 3) {
					$(".part3", kits).focus();
				}
				if (part == 3 && val.length > 4) {
					this.value = val.slice(0, 4);
				}
			}
		};
		$(document).on("input propertychange keyup", ".part1", func);
		$(document).on("input propertychange keyup", ".part2", func);
		$(document).on("input propertychange keyup", ".part3", func);
		$(document).on("focus", ".kitsendused input", function () {
			var $this = $(this);
			$this.parent().addClass("input-focus");
			$this.removeAttr("placeholder");
		})
		$(document).on("blur", ".kitsendused input", function () {
			var $this = $(this);
			$this.parent().removeClass("input-focus");
			if (!$this.val() && $this.parent().hasClass("split-input-wrapper")) {
				if ($this.hasClass("part1")) {
					$this.attr("placeholder", "00000");
				}
				if ($this.hasClass("part2")) {
					$this.attr("placeholder", "000");
				}
				if ($this.hasClass("part3")) {
					$this.attr("placeholder", "0000");
				}
			}
			if ($this.parent().hasClass("split-input-wrapper")) {
				//if (MO.getCadastreCode($this.closest(".kitsendused-container")) !== false) {
				//	console.log("$this.parent().siblings(\".add-cadastral-identification\")", $this.parent().siblings(".add-cadastral-identification"));
				//	$this.parent().siblings(".add-cadastral-identification").trigger("click");
				//}
			}
		});
		$(document).on("click", ".cadastral-clear", function () {
			let $this = $(this),
				$siblings = $this.siblings(".kitsendused")
			;
			$siblings.find("input").val("");
			$this.hide();
			$siblings.find(".part1").attr("placeholder", "00000");
			$siblings.find(".part2").attr("placeholder", "000");
			$siblings.find(".part3").attr("placeholder", "0000");
		});
		$(".tabs").each(function () {
			var $tabwrapper = $(this),
				tab_group = $tabwrapper.data("group");

			$(".tab", $tabwrapper).on("click", function () {
				var $tab = $(this),
					tab_active = $tab.data("active");

				$tab.siblings("a").removeClass("active");
				$tab.addClass("active");

				$("." + tab_group).hide();
				$("." + tab_group + "-" + tab_active).show();

				return false;
			});
		});
		// Dev Martin
		//$tab.siblings("a").removeClass("active");
		//input
		$(".cadastre-input").on("propertychange keyup input", function (e) {
			var $this = $(this),
				val = $this.val(),
				re = /^(\d{5}):(\d{3}):(\d{4})$/,
				res;
			
			console.log('DATA', val, e.type, e.keyCode, val.length);
			if (val === '') {
				$('.cadastre-data').hide();
				$('#ky-error').hide();
				$('#ky_action').removeAttr('disabled');
			}

			if (e.type == "keyup") {
				if (e.keyCode != 8) { // delete number
					if (val.length == 5) {
						val = val + ":";
						this.value = val;
					} else if (val.length == 9) {
						val = val + ":";
						this.value = val;
					}
					if (val.length > 14) {
						this.value = val.slice(0, 14);
					}
				}
			} else {
				if (val != "") {
					res = re.exec(val);
					$('.cadastre-data').hide();
					$('#ky-error').hide();
					$('#ky_action').removeAttr('disabled');
					if (!res) {
						this.val = "";
					}
				}
			}
		});
		//input
		$(".formatted-number-input").on("propertychange keyup", function (e) {
			this.value = this.value.toString().replace(/ /g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		});
		$("#metsauhistu_liige_jah").on("click", function () {
			$("#mu_member").show();
			$("#not_member").hide();
		});
		$("#metsauhistu_liige_ei").on("click", function () {
			$("#not_member").show();
			$("#mu_member").hide();
		});
		$(document).on("change", ".muu-kulu", function () {
			MO.calcKuluTotal();
		});
		$(document).on("keyup", "#pakkumine", function () {
			MO.calcPakkumine();
			//MO.calcOffer();
		});
		this.refresh();

		$(".transport-tabs").on("click", "a", function () {
			var key = $(this).data("key");
			var active = $(this).parent().hasClass("active");

			$(this).closest("ul").children().removeClass("active");
			$(".veohinnad-blokk").hide();
			//$("#veohinnad-DAP").hide();
			//$("#veohinnad-DAT").hide();
			if (!active) {
				$(this).parent().addClass("active");
				$("#veohinnad-" + key).show();
			}
			return false;
		});


		$(document).on("click", ".email-button", function () {
			MO.calculatorFeedback(this);
			return false;
		});

		//kits = $(".email-box", $(".module-hinnakalkulaator"));
		//func = ;
		$("input", $(".email-box")).on("input propertychange keyup", function (e) {
			//console.log(typeof e.keyCode, e.keyCode);

			if (e.keyCode === 13) {
				MO.calculatorFeedback(this);
				return false;
			} else {
				if (this.className === "input-error") {
					this.className = "";
				}
			}
		});
		//$(".name", kits).on("input propertychange keyup", func);
		//$(".phone", kits).on("input propertychange keyup", func);

		$(document).on("click", ".track-button", function (e) {
			/*
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'Calculator',
                'eventAction': 'HowToFind'
            });
            */
		});

		$(document).on("click", ".calculator-button", function () {
			var $this = $(this),
				$wrapper = $this.closest(".calculator-tab"),
				val = MO.getCadastreCode($wrapper);

			if ($(".calculator-tab").length) {
				/*
                dataLayer.push({
                    'event': 'GAEvent',
                    'eventCategory': 'Calculator',
                    'eventAction': 'FindData'
                });
                */
				if (activeCalculatorTab == "metsamaa") {
					dataLayer.push({
						'event': 'GAEvent',
						'eventCategory': 'metsakinnistu kalkulaator',
						'eventAction': 'metsakinnistu katastriotsing'
					});
				} else if (activeCalculatorTab == "raieoigus") {
					dataLayer.push({
						'event': 'GAEvent',
						'eventCategory': 'metsa raie kalkulaator',
						'eventAction': 'metsaraie katastriotsing'
					});
				} else if (activeCalculatorTab == "pollumajandusmaa") {
					dataLayer.push({
						'event': 'GAEvent',
						'eventCategory': 'põllumaa kalkulaator',
						'eventAction': 'põllumaa katastriotsing'
					});
				}
			}

			var activeTab = $("li.active", $(".calc-tabs-wrapper")).find("a").attr("href");

			$.ajax({
				url: "/resolve_ky/" + val,
				timeout: 15000,
				success: function (data) {
					log(data);
					var pieces = [];

					if (typeof data === "object") { // && data[1]
						$("[data-calculator-step='1']", $wrapper).hide();
						$("[data-calculator-step='2']", $wrapper).show();

						console.log(data);

						pieces.push(data["Maakond"]);
						pieces.push(data["Omavalitsus"]);
						pieces.push(data["Asustusüksus"]);
						pieces.push(data["Lähiaadress"]);

						var $maakond = $("input[name='maakond']", $wrapper);
						if ($maakond) {
							$maakond.val(data["Maakond"]);
						}

						var $katastritunnus = $("input[name='katastritunnus']", $wrapper);
						if ($katastritunnus) {
							$katastritunnus.val(val);
						}

						var $metsamaa = $("input.metsamaa", $wrapper);
						if ($metsamaa.length) {
							$metsamaa.val(MO.convertToHa(data["Metsamaa"]));
						} else {
							//var pindala_val = data["Pindala"].split(' ')[0];

							if (activeTab !== "#tab2") {
								var $pindala = $("input[name='kogus']", $wrapper);
								//console.log($pindala);
								if ($pindala) {
									$pindala.val(MO.convertToHa(data["Pindala"]));
									//$pindala.val( pindala_val );
								}
							}
						}


						var $haritav = $("input[name='haritav']", $wrapper);
						if ($haritav) {
							$haritav.val(MO.convertToHa(data["Haritav maa"]));
						}
						var $rohumaa = $("input[name='rohumaa']", $wrapper);
						if ($rohumaa) {
							$rohumaa.val(MO.convertToHa(data["Rohumaa"]));
						}

						var calc_res_link = '<a class="calculator-results-county" href="https://xgis.maaamet.ee/ky/' + val + '" target="_blank">' + pieces.join(", ") + '</a>';

						$(".calculator-results-cadastral", $wrapper).html(data.Tunnus);
						$(".calculator-results-county-p", $wrapper).html(calc_res_link);
						$(".calculator-results-county-input", $wrapper).val(pieces.join(", "));

					} else {
						// Error
						log(data);
						$this.siblings(".split-input-wrapper ").addClass("input-error");

					}
				}
			});
			// 85801:002:0374
			return false;
		});

		$(document).on("click", ".calculator-reset", function () {
			MO.calculatorReset(this);
		});
		$(document).on("click", ".recalc", function () {
			MO.calculatorAmount(this);
		});

		if (MO.loggedIn()) {
			$("[data-logged-in='false']").hide();
			$("[data-logged-in='true']").show();
		} else {
			$("[data-logged-in='true']").hide();
			$("[data-logged-in='false']").show();
		}
		$(document).on("change", ".puuliik", function () {
			//MO.calculatorAmount(this);
		});
		$(document).on("keyup", ".kogus", function (e) {
			var $this = $(this),
				val = $this.val();

			//console.log(typeof e.keyCode, e.keyCode);

			if (e.keyCode === 13) {
				//MO.calculatorAmount(this);
				return false;
			}

			val = val.toString().replace(/,/g, ".");
			val = val.replace(/[^\d\.]/g, "");
			$this.val(val);

			if ($this.data("value") !== val) {
				$this.data("value", val);

				//MO.calculatorAmount(this);
			}
		});

		// 81001:001:0900
		$(document).on("submit", "form.ajax", function () {
			var $form = $(this);
			var $wrapper = $form.closest(".calculator-tab");
			var $resultsText = $(".calculating-results-done-text");

			//console.log("form:", $form);

			$.ajax({
				url: $form.attr("action"),
				type: "post",
				dataType: "json",
				data: $form.serialize(),
				beforeSend: function () {
					//MO.startSpin();
				},
				complete: function () {
					//MO.stopSpin();
					setTimeout(function () {
						$(".calculating-results-loading", $wrapper).hide();
						$(".calculating-results-done", $wrapper).show();
					}, 2000);
				},
				success: function (data) {
					log(data);
					var $wrapper = $(".block-" + data.mida);

					if (data.error) {
						$(".calculating-results-done", $wrapper).html("<div class=\"message warning\"><i class=\"fas fa-exclamation-triangle\"></i><p>" + data.error + "</p></div>");

						$("html, body").animate({
							scrollTop: ($(".calculator-body", $wrapper).offset().top - 250)
						}, 500);
					} else {
						if (data.salvestan) {
							if (data.salvestan == 1) {
								$(".email-box", $wrapper).hide();
								$(".sent-message-box", $wrapper).show();

							}
						} else {
							$(".email-box", $wrapper).show();
							$(".sent-message-box", $wrapper).hide();

							$(".alus-tekst", $wrapper).show();
							setTimeout(function () {
								if (MO.loggedIn()) {
									$resultsText.html("Kalkulatsioon tehtud");
								} else {
									$resultsText.html("Raport on valmis ja saadetud Sinu e-posti aadressile<br>Raporti sisu tutvustamiseks võetakse Sinuga telefonitsi või e-kirja teel ühendust 5 tööpäeva jooksul.");

								}
								if (data.mida === "metsamaterjal") {
									$(".calculator-footer", $wrapper).find("h1").html(data.hind);
									$(".calculator-footer", $wrapper).show();
								} else if (data.mida === "raieoigus" || data.mida === "metsamaa" || data.mida === "pollumajandusmaa") {
									var $list = $(".calculator-footer", $wrapper).find("h1");
									$list.first().html(data.minimaalne);
									if (data.mida === "metsamaa" || data.mida === "pollumajandusmaa") {
										$list.eq(1).html(data.keskmine);
									}
									$(".calculator-footer-info", $wrapper).show();
									$list.last().html(data.maksimaalne);
									$(".email-box-cadastre", $wrapper).find("a").html(data.katastritunnus);
									$(".soovin-osta-link").attr("href", $(".soovin-osta-link").attr("href") + data.katastritunnus);
									$(".calculator-footer", $wrapper).show();
									$(".calculator-contact", $wrapper).show();

								}
								$("html, body").animate({
									scrollTop: $(".calculator-body", $wrapper).offset().top
								}, 750);
							}, 2000);
						}
					}
				}
			});
			return false;
		});

		// Minu andmed
		this.gmapservice();

		this.mainpageMap();

		if (MODULE_NAME === "e_agent") {

			$("#smallSwitch").on("change", function () {
				var value = this.checked;
				console.log(value);

				$.getJSON(WWW_INDEX + "?f=e_agent", {e_agent: (value ? 1 : 0)}, function () {
					handleClick(value);

				})
			});
			$(".save-km").on("click", function () {
				var value = $("#km").val();
				var haritavat_maad = $("#haritavat_maad").val();
				var looduslikku_maad = $("#looduslikku_maad").val();
				var metsamaad = $("#metsamaad").val();
				var muud_maad = $("#muud_maad").val();

				document.querySelector(".success").style.display = "none";
				document.querySelector(".warning").style.display = "none";

				$.getJSON(WWW_INDEX + "?f=e_agent", {
					km: value,
					haritavat_maad: haritavat_maad,
					looduslikku_maad: looduslikku_maad,
					metsamaad: metsamaad,
					muud_maad: muud_maad
				}, function (result) {
					if (result) {
						if (result.status) {
							//document.querySelector("#uku-raadius").innerHTML = value;

							document.querySelector(".success").style.display = "block";
						} else {
							document.querySelector(".warning").style.display = "block";
						}
					} else {
						document.querySelector(".warning").style.display = "block";
					}
				});
				return false;
			});
			$(".delete-eaj").on("click", function () {
				var $this = $(this);
				var value = $this.data("id");
				console.log(value);

				$.getJSON(WWW_INDEX + "?f=e_agent", {delete: value}, function () {
					$this.closest("tr").remove();
					document.location.reload(true);
				});
				return false;
			});

			handleClick = function() {
				let isChecked = document.querySelector("#smallSwitch").checked;
				let eagentTextTitle = document.querySelector("#eagent-text-title")
				let eagentText = document.querySelector("#eagent-text")
				let eagentStatusBox = document.querySelector(".eagent-status-box")
				if (isChecked) {
					eagentTextTitle.innerHTML = "<img class='uku-logo' src='/images/brands/uko-logo-bordered.png'> on sisse lülitatud";
					eagentText.innerHTML = "Lülita välja";
					eagentStatusBox.classList.add('eagent-on')

				} else {
					eagentTextTitle.innerHTML = "<img class='uku-logo' src='/images/brands/uko-logo-bordered.png'> on välja lülitatud";
					eagentText.innerHTML = "Lülita sisse";
					eagentStatusBox.classList.remove('eagent-on')
				}

			}

			handleClick();
		}


		if (MODULE_NAME === "kaardirakendus") {
			$(".map-tabs").on("click", "a", function () {
				var $this = $(this),
					$parent = $this.parent(),
					block = $this.data("block"),
					$daily = $(".daily"),
					$monthly = $(".monthly"),
					$yearly = $(".yearly"),
					$radio = $this.find("input[type=radio][name=kaardipakett]");

				$parent.siblings().removeClass("active");
				$parent.addClass("active");
				/* $("input[type=radio][name=kaardipakett]").attr("checked", "checked");*/

				$parent.siblings().find("input[type=radio][name=kaardipakett]").prop("checked", false);
				//console.log(block, $radio);

				if (block === "daily") {
					$daily.show();
					$monthly.hide();
					$yearly.hide();
					//$radio.attr("checked", true)
				} else if (block === "monthly") {
					$daily.hide();
					$monthly.show();
					$yearly.hide();
					//$radio.attr("checked", true)
				} else {
					$daily.hide();
					$yearly.show();
					$monthly.hide();
					//$radio.attr("checked", true)
				}
				$radio.prop("checked", true);

				return false;
			});
		}

		log("Metsaoksjon ready");
	};
	this.calculatorFeedback = function (event) {
		var $this = $(event),
			$wrapper = $this.closest(".calculator-tab"),
			$box = $(".email-box", $wrapper),
			$priv = $("input[name='privaatsus']:checked", $box),
			$name = $("input[name='name']", $box),
			name = $name.val(),
			$email = $("input[name='email']", $box),
			email = $email.val(),
			$phone = $("input[name='phone']", $box),
			phone = $phone.val(),
			$form = $("form", $wrapper);
		log("event", event, name, email, phone);

		if (name === "") {
			$name.addClass("input-error");
		} else if (email === "") {
			$email.addClass("input-error");
		} else if (phone === "") {
			$phone.addClass("input-error");
		} else {
			$("input[name='action']", $wrapper).val("contact");

			$form.submit();
			/*
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'Calculator',
                'eventAction': 'Feedback'
            });*/
		}
	}
	this.calculatorReset = function (event, undefined) {
		var $this = $(event),
			$wrapper = $this.closest(".calculator-tab");
		$(".part1").attr("placeholder", "00000");
		$(".part2").attr("placeholder", "000");
		$(".part3").attr("placeholder", "0000");
		/*
        dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'Calculator',
            'eventAction': 'Reset'
        });
        */
		if (activeCalculatorTab == "metsamaa") {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'metsakinnistu kalkulaator',
				'eventAction': 'alusta uuesti'
			});
		} else if (activeCalculatorTab == "raieoigus") {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'metsa raie kalkulaator',
				'eventAction': 'alusta uuesti'
			});
		} else if (activeCalculatorTab == "pollumajandusmaa") {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'põllumaa kalkulaator',
				'eventAction': 'alusta uuesti'
			});
		}


		$("[data-calculator-step='2'], [data-calculator-step='3']", $wrapper).hide();
		$(".calculator-footer", $wrapper).hide();
		$(".calculator-contact", $wrapper).hide();
		$(".calculator-footer-info", $wrapper).hide();
		$("[data-calculator-step='1']", $wrapper).show();
	}
	// 81001:001:0900
	this.calculatorAmount = function (event, undefined) {
		var $this = $(event),
			$wrapper = $this.closest(".calculator-tab"),
			what = $wrapper.data("what"),
			type = $this.attr("type"),

			$kogus = $(".kogus", $wrapper),
			kogus = ($kogus.length ? $kogus.val().trim() : 0),

			$haritav = $(".haritav", $wrapper),
			haritav = ($haritav.length ? $haritav.val().trim() : 0),

			$rohumaa = $(".rohumaa", $wrapper),
			rohumaa = ($rohumaa.length ? $rohumaa.val().trim() : 0),

			$puuliik = $(".puuliik", $wrapper),
			puuliik = ($puuliik ? $puuliik.val() : 0),
			$form = $("form", $wrapper),
			raieid = $("input[name=raieid]:checked", $wrapper).val(),
			metsateatis = $("input[name=metsateatis]:checked", $wrapper).val(),
			privaatsus = $("input[name=privaatsus]:checked", $wrapper).val(),
			email = $("input[name=email_new]", $wrapper).val(),
			telefon = $("input[name=telefon]", $wrapper).val();

		console.log("what:", what, "type:", type, "kogus:", kogus, "rohumaa:", rohumaa, "puuliik:", puuliik, "raieid:", raieid, "metsateatis:", metsateatis);

		console.log(email);
		console.log(telefon);

		if (kogus == "") {
			$("input[name=kogus]", $wrapper).addClass("input-error");
		}

		if (what === "pollumajandusmaa") {
			if (haritav == "") {
				$("input[name=haritav]", $wrapper).addClass("input-error");
			}
			if (rohumaa == "") {
				$("input[name=rohumaa]", $wrapper).addClass("input-error");
			}
		}

		if (what === "metsamaa" && !raieid) {
			$("input[name=raieid]", $wrapper).addClass("input-error");
		}
		if (what === "raieoigus" && !metsateatis) {
			$("input[name=metsateatis]", $wrapper).addClass("input-error");
		}

		if ((what === "metsamaa" || what === "raieoigus") && email == '') {
			$("input[name=email_new]", $wrapper).addClass("input-error");
		}

		if (telefon == '') {
			$("input[name=telefon]", $wrapper).addClass("input-error");
		}

		if ((what === "metsamaa" || what === "raieoigus") && !privaatsus) {
			$("input[name=privaatsus]", $wrapper).addClass("input-error");
		}

		if ((what === "metsamaterjal" || what === "raieoigus") && !puuliik) {
			$("select[name=puuliik]", $wrapper).addClass("input-error");
		}

		var validated = false;

		if (what === "pollumajandusmaa") {
			if (haritav !== "" && rohumaa !== "") {
				validated = true;
			}
		} else if (MO.loggedIn()) {
			if (kogus !== "" && puuliik !== "" && ((what === "metsamaterjal") ||
				(what === "raieoigus" && metsateatis) ||
				(what === "metsamaa" && raieid))) {
				validated = true;
			}
		} else {
			if (kogus !== "" && puuliik !== "" && ((what === "metsamaterjal") ||
				(what === "raieoigus" && email != '' && metsateatis && privaatsus) ||
				(what === "metsamaa" && email != '' && raieid && privaatsus))) {
				validated = true;
			}
		}

		if (telefon == '') {
			if (!MO.loggedIn()) {
				validated = false;
			}
		}

		if (validated) {
			$("[data-calculator-step='2']", $wrapper).hide();
			$("[data-calculator-step='3']", $wrapper).show();
			$("input[name=raieid]", $wrapper).removeClass("input-error");
			$("input[name=metsateatis]", $wrapper).removeClass("input-error");
			$("input[name=email_new]", $wrapper).removeClass("input-error");
			$("input[name=telefon]", $wrapper).removeClass("input-error");
			$("input[name=kogus]", $wrapper).removeClass("input-error");
			$("input[name=haritav]", $wrapper).removeClass("input-error");
			$("input[name=rohumaa]", $wrapper).removeClass("input-error");
			$("input[name=privaatsus]", $wrapper).removeClass("input-error");
			$("select[name=puuliik]", $wrapper).removeClass("input-error");

			if (this.calculatorTimer) {
				clearTimeout(this.calculatorTimer);
				this.calculatorTimer = 0;
			}

			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'Calculator',
				'eventAction': 'Calculate'
			});

			if (type === "text") {
				this.calculatorTimer = setTimeout(function () {
					$("input[name='action']", $wrapper).val("calc");
					$form.submit();
				}, 500);
			} else {
				$("input[name='action']", $wrapper).val("calc");
				$form.submit();
			}
		} else {
			$(".calculator-footer", $wrapper).hide();
			$(".calculator-contact", $wrapper).hide();
		}
	}
	this.getCadastreLink = function (wrapper) {

		val = this.getCadastreCode(wrapper);
		if (!val) {
			return false;
		}

		return WWW_INDEX + "?ky=" + val;
	}
	this.getCadastreCode = function (wrapper) {
		var kits = wrapper || $("#kitsendused"),
			val = "",
			re = /^(\d{5}):(\d{3}):(\d{4})$/,
			$splitInputWrapper = $(".split-input-wrapper");
		val += $(".part1", kits).val();
		val += ":" + $(".part2", kits).val();
		val += ":" + $(".part3", kits).val();
		if ($splitInputWrapper.length) {
			if ((val === "::" || !re.test(val))) {
				wrapper.find(".split-input-wrapper").addClass("input-error");
				return false;
			} else {
				wrapper.find(".split-input-wrapper").removeClass("input-error");
			}
		}
		return val;
	}
	this.searchCadastre = function (link) {
		if (!link) {
			var link = this.getCadastreLink();
		}
		ga('send', 'event', 'General', 'cadastral_search');
		$.ajax({
			url: link,
			timeout: 1000,
			success: function (data) {
				log(data);
				if (data == "0") {
					$("#kitsendused input").val("");
				}
			}
		});
	}
	this.setAuctionLink = function (link) {
		this.auctionLink = link;
	}
	this.setRefreshItems = function (data) {
		this.refreshItems = data;
	}
	this.refresh = function () {
		var self = this;
		if (this.refreshTimer) {
			window.clearTimeout(this.refreshTimer);
		}
		if (this.auctionLink != "") {
			this.showRefreshLoader(this.refreshItems);
			$.ajax({
				url: self.auctionLink + "&auto-refresh=1",
				data: self.refreshItems
			}).always(function (data) {
				self.hideRefreshLoader();
			}).done(function () {
				if (self.refreshTimeout) {
					self.refreshTimer = self.sleep(self.refreshTimeout, function () {
						self.refresh();
					});
				}
			}).fail(function () {
				if (typeof error_ajax_query_failed != "undefined") {
					n = self.notify(error_ajax_query_failed, "error");
				}
			});
		}
	}
	this.setRefreshTimeout = function (time) {
		this.refreshTimeout = time;
	}
	this.showRefreshLoader = function (items) {
		var $o;
		for (var name in items) {
			if (items.hasOwnProperty(name)) {
				$o = $("#" + name);
				if ($o.length) {
					$o.find(".item-loader").show();
				}
			}
		}
	}
	this.hideRefreshLoader = function () {
		$(".item-loader").fadeOut("fast");
	}
	this.sleep = function (time, func, aArgs) {
		time = (time || 1) * 1000;
		var self = this;
		return window.setTimeout(function () {
			func.apply(self, aArgs);
		}, time);
	}
	this.offerPreCheck = function () {
		var check = 0,
			ferry = 0;

		if (typeof getFerry == "function") {
			ferry = getFerry();
		}

		//log("ferry", ferry);
		if (ferry) {
			check = 0;
			$(".muu-kulu-ylevedu").each(function () {
				var $o = $(this);
				if ($o.find("input").is(":checked")) {
					check += 1;
				}
			});
			if (!check) {
				n = this.notify(warning_ylevedu_valimata, "warning");
				return 0;
			} else if (check > 1) {
				n = this.notify(warning_mitu_ylevedu_valitud, "warning");
				return 0;
			}
		}
		return 1;
	}
	this.makeOffer = function ($this) {
		var $o = $($this),
			i = $o.data("i"),
			f = $o.data("f"),
			form = $("#mainForm"),
			self = this;
		log("i", i);
		log("f", f);
		$.noty.closeAll();
		if (this.offerPreCheck()) {
			$.ajax({
				url: form.attr("action"),
				type: "post",
				dataType: "json",
				data: form.serialize(),
				beforeSend: function () {
					self.startSpin();
				},
				complete: function () {
					self.stopSpin();
				},
				success: function (data) {
					var n;
					log(data);
					if (data.confirm) {
						n = self.confirm(data.confirm);
					} else if (data.success) {
						log("hide #set-route");
						$("#set-route").hide();
						n = self.notify(data.success, "success");
						// Bid was accepted, refresh auction data
						log("Bid was accepted, refresh auction data");
						self.refresh();
					} else if (data.error) {
						n = self.notify(data.error, "error");
					} else if (data.warning) {
						n = self.notify(data.warning, "warning");
					} else if (data.information) {
						n = self.notify(data.information, "information");
					}
					log(n);
				}
			});
		}
		/*
         this.startSpin();
         this.sleep(3, function () {
         this.stopSpin();
         });
         */
		return false;
	}
	this.confirm = function (text) {
		n = noty({
			text: text,
			type: "alert",
			dismissQueue: true,
			layout: "center",
			theme: "defaultTheme",
			buttons: [{
				addClass: "btn btn-primary",
				text: "Ok",
				onClick: function ($noty) {
					$noty.close();
					//noty({ dismissQueue: true, force: true, layout: layout, theme: "defaultTheme", text: "You clicked OK button", type: "success"});
				}
			},
				{
					addClass: "btn btn-danger",
					text: "Cancel",
					onClick: function ($noty) {
						$noty.close();
						//noty({ dismissQueue: true, force: true, layout: layout, theme: "defaultTheme", text: "You clicked Cancel button", type: "error"});
					}
				}
			]
		});
		return n;
	}
	this.notify = function (text, type, autoclose) {
		n = noty({
			text: text,
			type: type,
			dismissQueue: true,
			layout: "center",
			theme: "defaultTheme"
		});
		if (autoclose && autoclose >= 1) {
			this.sleep(autoclose, function () {
				n.close();
			});
		}
		return n;
	}
	this.success = function (text, autoclose) {
		if (!autoclose) {
			autoclose = 0;
		}
		return this.notify(text, "success", autoclose);
	}
	this.warning = function (text, autoclose) {
		if (!autoclose) {
			autoclose = 0;
		}
		return this.notify(text, "warning", autoclose);
	}
	this.error = function (text, autoclose) {
		if (!autoclose) {
			autoclose = 0;
		}
		return this.notify(text, "error", autoclose);
	}
	this.makeSpinner = function () {
		var opts = {
			lines: 17, // The number of lines to draw
			length: 20, // The length of each line
			width: 10, // The line thickness
			radius: 30, // The radius of the inner circle
			corners: 1, // Corner roundness (0..1)
			rotate: 0, // The rotation offset
			direction: 1, // 1: clockwise, -1: counterclockwise
			color: '#000', // #rgb or #rrggbb or array of colors
			speed: 1.5, // Rounds per second
			trail: 60, // Afterglow percentage
			shadow: true, // Whether to render a shadow
			hwaccel: true, // Whether to use hardware acceleration
			className: 'spinner', // The CSS class to assign to the spinner
			zIndex: 2e9, // The z-index (defaults to 2000000000)
			top: '40px', // Top position relative to parent in px
			left: '40px' // Left position relative to parent in px
		};
		this.spinner = new Spinner(opts);
	}
	this.startSpin = function () {
		var target = document.getElementById("spinner-wrapper");
		$(target).show();
		this.spinner.spin(target);
	}
	this.stopSpin = function () {
		var self = this;
		$("#spinner-wrapper").fadeOut("fast", function () {
			self.spinner.stop();
		});
	}
	this.clearOffer = function () {
		$("#offer-price").html("-");
		$("#arvuta").val(0);
	}
	this.calcOffer = function () {
		var $o = $("#pakkumine"),
			val = $o.val(),
			pakkumine = parseFloat(val) || 0,
			kulud = parseFloat($("#price_total").val()) || 0,
			total = (kulud + pakkumine);


		$("#offer-price").html(total.toFixed(2));
		$("#arvuta").val(1);
		//this.notify("Pakutav hind on arvutatud", "success", 1);
		return false;
	}
	this.calcPakkumine = function () {
		var $o = $("#pakkumine"),
			val = $o.val();

		var result = /^[\d.]+$/.test(val);
		if (!result) {
			val = val.replace(/,/g, ".");

			$o.val(val.replace(/[^\d.]/g, ""));
		}
		this.clearOffer();
	}
	this.calcMuuKulu = function () {
		var total = 0;
		$("input.muu-kulu").each(function () {
			var $o = $(this);
			if ($o.is(":checked")) {
				total += parseFloat($o.val()) || 0;
			}
		});
		var total_fixed = total.toFixed(2);

		console.log("calcMuuKulu", total, total_fixed)

		$("#muu-row-price").html(total_fixed);
		$("#price_muu").val(total);
	}
	this.calcKuluTotal = function () {
		console.log("calcKuluTotal");
		this.calcMuuKulu();
		var price_FOB = parseFloat($("#price_FOB").val()) || 0;
		console.log("price_FOB", price_FOB);
		var price_DAT = parseFloat($("#price_DAT").val()) || 0;
		console.log("price_DAT", price_DAT);
		var price_DAP = parseFloat($("#price_DAP").val()) || 0;
		console.log("price_DAP", price_DAP);
		var price_muu = parseFloat($("#price_muu").val()) || 0;
		console.log("price_muu", price_muu);
		var price_teemaks = parseFloat($("#price_teemaks").val()) || 0;
		console.log("price_teemaks", price_teemaks);
		var total = (price_FOB + price_DAT + price_DAP + price_muu + price_teemaks);
		var total_fixed = total.toFixed(2);

		console.log("total", total, total_fixed);
		$("#total-row-price").html(total_fixed);
		$("#price_total").val(total);
		//this.calcPakkumine();
		this.clearOffer();
	}
	this.resetMobileForId = function () {
		$("#mobile-for-id").val("");
		$("#msg-mobile-id").html("");
		$("#msg-mobile-id").hide();
	}
	this.authByMobileID = function (what) {
		if (!what) {
			what = "mid";
		}

		console.log('LOGIN', loginMethod, what)

		loginMethod = what;

		if (loginMethod == "sid") {
			$("#header-for-mid").hide();
			$("#header-for-sid").show();
			$(".number-begin").hide();
			$("#personalcode-for-id").hide();
		} else {
			$("#header-for-mid").show();
			$("#header-for-sid").hide();
			$(".number-begin").show();
			$("#personalcode-for-id").show();
		}

		$("#mobile-id").hide().slideDown("fast");
		//$("#mobile-id").show();
		$("#mobile-enter-info").show();
		$("#exec-mobile-id").show();
		this.resetMobileForId();

		$("#mobile-for-id").focus();
		//$("#mobile-for-id").val($("#mobile-for-id").val());
		return false;
	}
	this.execMobileID = function () {
		var nr = $("#mobile-for-id").val();
		if (nr && nr != "") {
			$("#mobile-enter-info").hide();
			$("#exec-mobile-id").hide();
			this.processMobileID();
			this.resetMobileForId();
		} else {
			$("#mobile-for-id").focus();
		}
		return false;
	}
	this.processMobileID = function (number) {
		var mobNo = $("#mobile-for-id").val(),
			pcode = $("#personalcode-for-id").val(),
			_post = {
				mobileForId: mobNo,
				personalcodeForId: pcode,
			},
			session_id = this.getCookie('l_sid');

		if (loginMethod === "sid") {
			$.ajax({
				type: "POST",
				url: SMART_ID_AUTH_URL,
				data: {
					smartIdLogin: mobNo,
					session_id: session_id,
					phase: 1
				},
				cache: false,
				dataType: "html",
				beforeSend: function () {
					$("#msg-mobile-id").html("Toimub autoriseerimine...");
					$("#msg-mobile-id").css({
						display: "block"
					});
				},
				success: function (data) {
					let message = "Saadame autentimise päringut teie telefoni...<br>Portaali haldaja: Maaportaal OÜ <p>Kinnituskood on: <strong>" + data + "</strong></p> Palun kontrollige koodi vastavust enda telefonis kuvatavaga ja sisestage PIN1 kood.";

					$("#msg-mobile-id").html(message);
					$("#msg-mobile-id").css({
						display: "block"
					});

					$.ajax({
						type: "POST",
						url: SMART_ID_AUTH_URL,
						data: {
							smartIdLogin: mobNo,
							session_id: session_id,
							phase: 2
						},
						cache: false,
						timeout: 60000,
						dataType: "html",
						success: function (data) {
							if (data == "AUTHENTICATED") {
								$("#msg-mobile-id").html("Olete autoriseeritud, toimub sisenemine");
								location.reload();
							} else {
								$("#msg-mobile-id").html(data);
							}
							$("#msg-mobile-id").css({
								display: "block"
							});
						}
					});
				}
			});
		} else {
			$.ajax({
				type: "POST",
				url: WWW_INDEX,
				data: _post,
				beforeSend: function (xhr) {
					$("#msg-mobile-id").html("Toimub autoriseerimine...");
					$("#msg-mobile-id").show();
				},
				success: function (transport) {
					//eval(transport);
				},
				dataType: "script"
			});
		}
	}
	this.startSmartID = function (number) {
		$("#login-modal").show().removeAttr("class").addClass("popup-overlay smart-id-active");

		MO.authByMobileID("sid");

		$("#mobile-for-id").val(number);

		MO.execMobileID();
	}
	this.startMobileID = function (number) {
		$("#login-modal").show().removeAttr("class").addClass("popup-overlay mobile-id-active");

		MO.authByMobileID();

		$("#mobile-for-id").val(number);

		MO.execMobileID();
	}
	this.message = function (data) {
		log(data);
		if (data !== undefined && data && data.message) {
			alert(data.message);
		}
	}
	this.getCookie = function (cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1);
			if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
		}
		return "";
	}
	this.action = function ($this) {
		var $o = $($this),
			tag = $o.get(0).tagName,
			ret = true,
			set = $o.data("set"),
			moa = $o.data("action-mo"),
			form,
			$f,
			href;
		log(tag);
		if ($o.hasClass("disabled")) {
			return false;
		}
		if (set) {
			log(set);
			$.each(set, function (index, value) {
				log(value.target + ': ' + value.value);
				$(value.target).val(value.value);
			});
		}
		if (moa) {
			log("call", MO[moa]);
			MO[moa]($this);
			return false;
		}
		if ($o.hasClass("confirm")) {
			var text = $o.data("confirmText");
			if (!text) {
				text = "Oled sa kindel?";
			}
			if (!confirm(text)) {
				ret = false;
				return ret;
			}
		}
		if ($o.hasClass("toggle-popup")) {
			var target = $o.data("target");
			$(target).toggle();
			return false;
		}
		if ($o.hasClass("close-popup")) {
			if (window.innerWidth < 769 && !$('body').hasClass('menu-open')) {
				$('body').removeClass('overflow-hidden');
			}

			var $p = $o.closest(".popup-overlay");
			if ($p.length > 0) {
				$p.hide();
			}
			killClone()
			return false;
		}
		if ($o.hasClass("submit")) {
			form = $o.data("form");
			if (form) {
				$f = $(form);
			} else {
				$f = $o.closest("form");
			}
			if ($f.length > 0) {
				$f.submit();
			} else {
				alert("Error: Form not found!");
			}
			return false;
		}
		if (tag == 'A') {
			href = $o.attr("href");
		} else {
			href = $o.data("href");
		}
		if ($o.hasClass("ajax")) {
			$.ajax({
				url: href,
				success: function (data) {
					log(data);
				}
			});
			return false;
		}
		return ret;
	}
	this.setLat = function (lat) {
		this.lat = lat;
	}
	this.setLng = function (lng) {
		this.lng = lng;
	}
	this.setZoom = function (zoom) {
		this.zoom = zoom;
	}
	this.getLat = function () {
		return this.lat;
	}
	this.getLng = function () {
		return this.lng;
	}
	this.getZoom = function () {
		return this.zoom;
	}
	this.mapinitialize = function () {
		directionsService = new google.maps.DirectionsService();
		myLatlng = new google.maps.LatLng(MO.getLat(), MO.getLng());
		var myOptions = {
			zoom: MO.getZoom(),
			center: myLatlng,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		}
		map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
		google.maps.event.addListener(map, "click", function (event) {
			myLatlng = event.latLng;
			directionsService.route({
				origin: myLatlng,
				destination: myLatlng,
				travelMode: google.maps.DirectionsTravelMode.DRIVING
			}, function (response, status) {
				if (status == google.maps.DirectionsStatus.OK) {
					myLatlng = response.routes[0].legs[0].start_location;
				}
				marker.setPosition(myLatlng);

				$(".latitude-td input").val(myLatlng.lat());
				$(".longitude-td input").val(myLatlng.lng());
				//document.getElementById("latitude").value = myLatlng.lat();
				//document.getElementById("longitude").value = myLatlng.lng();
				map.setCenter(myLatlng);
			});
		});
		marker = new google.maps.Marker({
			position: myLatlng,
			map: map,
			title: "Marker"
		});
		marker.setDraggable(true);
	}
	this.gmapservice = function () {
		$(".show-map").on("click", function () {
			$(".map").toggle();
			var seen = $(this).data("seen");
			if (!seen) {
				MO.mapinitialize();
			}
			return false;
		});
	}
	this.checkOn = function (elm) {
		//log(elm);
		var $o = $(elm),
			group = $o.data("group");
		//log(group);
		//log($(group));
		$(group).attr("checked", true);
	}
	this.checkOff = function (elm) {
		//log(elm);
		var $o = $(elm),
			group = $o.data("group");
		$(group).attr("checked", false);
	}
	this.mainpageMap = function () {
		if (MODULE_NAME == "avaleht" || MODULE_NAME === "oksjoni_ulevaade") {
			$(".close-mobile-map").click(function () {
				setCookie("mapclosed6", "1", 1);
				location.reload();
				//$("body").addClass("mobile-map-closed");
				return false;
			});

			if (getCookie("mapclosed6") === "1") {
				$("body").addClass("mobile-map-closed");
			}

			window.addEventListener("load", function () {
				MO.initializeMaps();
			});
		}
	}
	this.initializeMaps = function () {
		var $this = this;
		if (MODULE_NAME === "avaleht") {
			$(".open-main-map").click(function () {
				$(".open-main-map").hide();
				$(".close-main-map").show();
				$(".map-wrapper").addClass("open").removeClass("closed");
				$.get("/map_state/1");
				return false;
			});
			$(".close-main-map").click(function () {
				$(".open-main-map").show();
				$(".close-main-map").hide();
				$(".map-wrapper").addClass("closed").removeClass("open");
				$.get("/map_state/0");
				return false;
			});

			if (USER_ID) {
				var mapOptions = {
					zoom: 7,
					center: new google.maps.LatLng(58.607566, 25.047626)
				};
			} else {
				var mapOptions = {
					zoom: 7,
					center: new google.maps.LatLng(58.607566, 25.047626),
					navigationControl: false,
					mapTypeControl: false,
					scaleControl: false,
					draggable: false,
					scrollwheel: false,
					disableDoubleClickZoom: true,
					disableDefaultUI: true
				};
			}
			this.initializeMap("map-canvas", mapOptions);

			$('#tab-map').on('click', function () {
				var $tabMap = $($this);

				if (!$tabMap.data("initialized")) {

					setTimeout(function () {
						$tabMap.data("initialized", true);
						mapOptions.zoom = 6;

						console.log("$this.initializeMap(\"map-canvas1\", mapOptions);");
						$this.initializeMap("map-canvas1", mapOptions);
					}, 200);
				}
			});
			if (getCookie("mapclosed6") !== "1") {
				this.initializeMap("mobile-map-canvas", mapOptions);
			}
		} else if (MODULE_NAME === "oksjoni_ulevaade") {
			var mapOptions = {
				zoom: 7,
				center: new google.maps.LatLng(58.607566, 25.047626),
			};
			this.initializeMap("map-canvas", mapOptions);
		}
	}
	this.initializeMap = function (mapId, mapOptions) {

		if (MODULE_NAME === "avaleht") {
			var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

			setMarkersKaart(map, pointers);
		} else if (MODULE_NAME === "oksjoni_ulevaade") {
			var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(myLatLng[0], myLatLng[1]),
				map: map,
				title: "Oksjon"
			});

			/*
		var myLatLng = {lat: -25.363, lng: 131.044};

		var map = new google.maps.Map(document.getElementById(mapId), {
			zoom: 4,
			center: myLatLng
		});

		var marker = new google.maps.Marker({
			position: myLatLng,
			map: map,
			title: 'Hello World!'
		});
		*/
		}
	}
	this.calculatorBoxClose = function (elm) {
		var $o = $(elm);
		var $cw = $o.closest(".row-calc-tabs");

		$o.closest(".calculator-tab").hide();
		$cw.find(".calc-tabs-wrapper").find("li").removeClass("active");
	}
}